import React from 'react';

interface ChatInfoProps {
  count_msg: number;
  name: string;
  time_last_msg?: string;
  last_message_text: string;
}
const ChatInfo = ({
  count_msg,
  name,
  time_last_msg,
  last_message_text,
}: ChatInfoProps) => {
  return (
    <div className="flex flex-col w-[80%]  justify-center gap-2">
      <div className="flex justify-between items-center">
        <span className="text-gray-950 text-md font-DemiBold">{name}</span>
        {count_msg > 0 && (
          <span className="text-white text-[8px] bg-farm-shop-500 rounded-full w-[12px] h-[12px] flex items-center justify-center">
            {count_msg}
          </span>
        )}
      </div>
      <div className="flex justify-between items-center">
        <span className="text-gray-700 text-md font-Regular max-w-[120px] truncate">
          {last_message_text}
        </span>
        <span className="text-gray-700 text-sm font-Regular">
          {time_last_msg && time_last_msg}
        </span>
      </div>
    </div>
  );
};

export default ChatInfo;
